import { Download, FolderInput, History, MoreVertical, Pencil, Share2, Tag, Trash2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@bookdental/ui";
import { useSoLeitura } from "@/components/organization/painel/OrganizacaoEmFoco";

export function FileActionsMenu({
  onDownload,
  onTags,
  onShare,
  onHistory,
  onRename,
  onMove,
  onDelete,
}: {
  onDownload?: () => void;
  /** Só pastas ficam sem essa ação — tag é conceito de File, não de Folder. */
  onTags?: () => void;
  /** Compartilhar/histórico também só fazem sentido pra arquivo, não pasta. */
  onShare?: () => void;
  onHistory?: () => void;
  onRename: () => void;
  onMove: () => void;
  onDelete: () => void;
}) {
  // Ficha só leitura de outra clínica: baixar e ver o histórico, nada que altere.
  const editar = !useSoLeitura();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
          aria-label="Mais ações"
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[180px] border-zinc-200 bg-white p-1 shadow-xl dark:border-border dark:bg-card"
      >
        {onDownload && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onDownload();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <Download className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Baixar
          </DropdownMenuItem>
        )}
        {editar && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onRename();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <Pencil className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Renomear
          </DropdownMenuItem>
        )}
        {editar && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onMove();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <FolderInput className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Mover
          </DropdownMenuItem>
        )}
        {editar && onTags && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onTags();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <Tag className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Tags
          </DropdownMenuItem>
        )}
        {editar && onShare && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onShare();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <Share2 className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Compartilhar
          </DropdownMenuItem>
        )}
        {onHistory && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onHistory();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm"
          >
            <History className="h-4 w-4 text-zinc-500 dark:text-muted-foreground" />
            Histórico
          </DropdownMenuItem>
        )}
        {editar && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm text-red-600 dark:text-red-400"
          >
            <Trash2 className="h-4 w-4" />
            Excluir
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
